import axios from '../utils/axios';

const ProgramsService = {
    // Registry
    getPrograms(params = {})       { return axios.get('programs', { params }); },
    saveProgram(data)              { return axios.post('programs/save', data); },
    deleteProgram(id)              { return axios.post('programs/delete', { id }); },

    // Assessments
    getAssessments(params = {})    { return axios.get('programs/assessments', { params }); },
    getAssessmentDetail(id)        { return axios.get(`programs/assessments/${id}`); },
    saveAssessment(data)           { return axios.post('programs/assessments/save', data); },
    saveResponses(data)            { return axios.post('programs/assessments/responses/save', data); },
    submitAssessment(id)           { return axios.post(`programs/assessments/${id}/submit`); },
    approveAssessment(id)          { return axios.post(`programs/assessments/${id}/approve`); },
    getReportData(id)              { return axios.get(`programs/assessments/${id}/report`); },
    returnForRevision(id, comment) { return axios.post(`programs/assessments/${id}/return`, { comment }); },

    // Assessor assignments
    getAssignments(params = {})    { return axios.get('programs/assessors', { params }); },
    assignAssessor(data)           { return axios.post('programs/assessors/assign', data); },
    removeAssessor(id)             { return axios.post('programs/assessors/remove', { id }); },
};

export default ProgramsService;